import { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';

export default function Map() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => setIsLoading(false),
        () => setIsLoading(false)
      );
    }

    const preventZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', preventZoom, { passive: false });
    return () => {
      document.removeEventListener('touchmove', preventZoom);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-8">
          <MapPin className="w-8 h-8 text-orange-500" />
          <h1 className="text-3xl font-bold">Hartă Trasee</h1>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {isLoading ? (
            <div className="flex items-center justify-center h-[80vh] bg-gray-50">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
                <p className="text-gray-600">Se încarcă harta...</p>
                <p className="text-sm text-gray-500 mt-2">Vă rugăm să permiteți accesul la locație</p>
              </div>
            </div>
          ) : (
            <div className="touch-pan-y">
              <iframe
                src="https://bikepark-theta.vercel.app/"
                className="w-full h-[80vh]"
                allowFullScreen
                allow="geolocation"
                style={{
                  touchAction: 'pan-y pinch-zoom',
                  WebkitOverflowScrolling: 'touch'
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}